import axiosInstance from "../../../api/axiosInstance";

export const fetchSquadImagesAPI = async () => {
  const imagesList = await axiosInstance.get("images/get-all-squad-images");

  return imagesList.data;
};

export const uploadSquadImagesAPI = async (imageData) => {
  const uploadedImage = await axiosInstance.post(
    "images/upload-image",
    imageData
  );

  return uploadedImage.data;
};

export const deleteSquadImageAPI = async (id) => {
  const deleteImageId = await axiosInstance.delete(`images/delete-image/${id}`);

  return deleteImageId.data;
};
